"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeSQLString = exports.convertData = exports.getAthenaClient = void 0;
const athena_client_1 = __importDefault(require("@missionlabs/athena-client"));
const utils_1 = require("../utils");
const getAthenaClient = async (company) => {
    const { athena } = company;
    if (!athena) {
        throw new Error('No athena config against instance');
    }
    const clientConfig = {
        bucketUri: 's3://' + athena.results,
        database: athena.database || 'smartagent_data_warehouse',
    };
    const credentials = await (0, utils_1.getCredentials)(athena.roleName || 'smartagent-data', athena.accountID, athena.externalID, athena.region || 'eu-west-2');
    return athena_client_1.default.createClient(clientConfig, credentials);
};
exports.getAthenaClient = getAthenaClient;
const convertData = (data) => {
    Object.keys(data).forEach(key => {
        if (data[key] === 'true') {
            data[key] = true;
        }
        else if (data[key] === 'false') {
            data[key] = false;
        }
    });
    return data;
};
exports.convertData = convertData;
const escapeSQLString = (expression) => {
    return expression.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, (char) => {
        switch (char) {
            case '\0':
                return '\\0';
            case '\x08':
                return '\\b';
            case '\x09':
                return '\\t';
            case '\x1a':
                return '\\z';
            case '\n':
                return '\\n';
            case '\r':
                return '\\r';
            case '"':
            case "'":
            case '\\':
            case '%':
                return '\\' + char; // prepends a backslash to backslash, percent,
            // and double/single quotes
            default:
                return char;
        }
    });
};
exports.escapeSQLString = escapeSQLString;
exports.default = exports.getAthenaClient;
